import {
  SEND_VERIFICATION_CODE,
  SEND_VERIFICATION_CODE_SUCCESS,
  SEND_VERIFICATION_CODE_ERROR,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_ERROR,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';

const onsiteBookingPatientReducer = handleActions(
  new Map([
    [
      SEND_VERIFICATION_CODE,
      state => {
        return update(state, {
          loadingStatus: {
            sendVerificationCodeLoading: { $set: true },
          },
        });
      },
    ],
    [
      SEND_VERIFICATION_CODE_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            sendVerificationCodeLoading: { $set: false },
          },
        });
      },
    ],
    [
      SEND_VERIFICATION_CODE_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            sendVerificationCodeLoading: { $set: false },
          },
        });
      },
    ],

    [
      VERIFY_CODE,
      state => {
        return update(state, {
          loadingStatus: {
            verifyCodeLoading: { $set: true },
          },
        });
      },
    ],
    [
      VERIFY_CODE_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            verifyCodeLoading: { $set: false },
          },
          patientInfo: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      VERIFY_CODE_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            verifyCodeLoading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default onsiteBookingPatientReducer;
